module.exports = __webpack_public_path__ + "img/symptoms.08212c69.svg";